<div class="modal-header">
    <h3>New {{ "Account" | smNomenclatureByRegion : program?.Id | async }}</h3>
    <button unity-button 
        class="icon-only xlarge close on_dark" 
        aria-label="Close"
        (click)="activeModal.dismiss('Cross click')">
        <svg class="unity-icon-times">
            <use xlink:href="#unity-icon-times"></use>
        </svg>
    </button>
</div>

<unity-stepper
    [steps]="accountCreationSteps"
    [currentStep]="accountCreationCurrentStep"
    [layoutDirection]="'horizontal'"
    [style]="'panels'"
    (goToStep)="changeStep($event)">
</unity-stepper>
 
<div class="modal-body-wrapper" [attr.inert]="childModalOpen ? true : null">
    <div class="modal-body">
    <div *ngIf="accountCreationCurrentStep == 0" (keyup.enter)="$event.stopPropagation(); next()">
        <div class="form-group">
            <label for="accountName">{{ "Account" | smNomenclatureByRegion : program?.Id | async }} Name <span class="text-danger">*</span></label>
            <input type="text" 
                [(ngModel)]="accountName"
                #nameInput name="accountName" 
                class="form-control"
                id="accountName" 
                placeholder="Organization Name, Co."
                autocomplete="off" 
                autofocus 
                ngbAutofocus>
        </div>
        <ng-container *sm-tenant-has-facet="TENANT_PERMISSIONS.Flag_Base_Work_Accounts_NewAccountNumberOverride">
            <div *ngIf="!isBureauEnabled" class="form-group">
                <label for="accountCode">{{ "Account" | smNomenclatureByRegion : program?.Id | async }} Number</label>
                <input type="text" 
                    [(ngModel)]="accountCode" 
                    name="accountCode" 
                    class="form-control" 
                    id="accountCode"
                    placeholder="System will generate if left blank"
                    autocomplete="off">
            </div>
        </ng-container>
        <div class="form-group">
            <label for="dba">DBA</label>
            <input type="text" 
                placeholder="Doing Business As" 
                [(ngModel)]="dba" 
                name="dba" 
                class="form-control"
                id="dba" 
                autocomplete="off">
        </div>
        <div *sm-tenant-has-facet="TENANT_PERMISSIONS.Flag_Base_Work_Accounts_BureauMode" class="form-group">
            <label for="legalEntity">Legal Entity</label>
            <select
                [(ngModel)]="legalEntity" 
                name="legalEntity" 
                class="form-select form-control" 
                id="legalEntity" 
                autocomplete="off"
            >
                <option *ngFor="let entity of legalEntities" [ngValue]="entity">{{entity}}</option>
            </select>
            <div *ngIf="legalEntity === 'Other'" class="mt-2">
                <input
                    id="otherLegalEntity"
                    type="text"
                    class="form-control"
                    placeholder="Specify other legal entity"
                    maxlength="60"
                    [(ngModel)]="otherLegalEntity"
                    autocomplete="off"
                />
            </div>
        </div>
        <div class="form-group">
            <label for="descriptionOfOperations">Description of Operations</label>
            <input type="text" 
                [(ngModel)]="descriptionOfOperations" 
                name="descriptionOfOperations" 
                class="form-control"
                id="descriptionOfOperations" 
                autocomplete="off">
        </div>
        <div class="form-group" #producer>
            <label>{{ "Producer" | smNomenclatureByRegion : program?.Id | async }}</label>
            <sm-producer-search (producerSelectedEvent)="setProducer($event)"></sm-producer-search>
        </div>
        <ng-container *sm-tenant-has-facet="TENANT_PERMISSIONS.Flag_Base_Work_Accounts_ExplicitProgramAccess">
            <div class="form-group mt-3">
                <label for="selectedProgram">Program <span class="text-danger">*</span></label>
                <select
                    name="selectedProgram"
                    [(ngModel)]="program"                    
                    class="form-select form-control"
                >
                    <option [ngValue]="undefined" disabled selected hidden>Select a Program...</option>
                    <option *ngFor="let prog of programs" [ngValue]="prog">
                        {{prog.Name}}
                    </option>
                </select>
            </div>
        </ng-container>
    </div>

    <div *ngIf="accountCreationCurrentStep == 1" (keyup.enter)="$event.stopPropagation(); createAccount(false)">
        <div class="form-group">
            <label for="country">Country <span class="text-danger">*</span></label>
            <select
                id="country"
                #countryInput
                class="form-select form-control"
                [(ngModel)]="country"
            >
                <option [ngValue]="'USA'">United States</option>
                <option [ngValue]="'GBR'">United Kingdom</option>
                <option [ngValue]="'CAN'">Canada</option>
            </select>
        </div>
        @if (country == 'USA') {
            <div class="form-group">
                <label for="fein">FEIN</label>
                <kendo-maskedtextbox
                    name="fein"
                    id="fein"
                    [(ngModel)]="fein"
                    [maxlength]="10"
                    [includeLiterals]="true"
                    mask="00-0000000"
                />
            </div>
        }
        <div class="form-group">
            <label for="phone">Phone <span class="text-danger">*</span></label>
            <input type="text" 
                placeholder="(  )    -" 
                [(ngModel)]="phone" 
                name="phone" 
                class="form-control" 
                id="phone"
                autocomplete="off">
        </div>
        <div class="form-group">
            <label for="address1">Address 1 <span class="text-danger">*</span></label>
            <input type="text" 
                placeholder="Address 1" 
                [(ngModel)]="address1" 
                name="address1" 
                class="form-control"
                id="address1" 
                autocomplete="off">
        </div>
        <div class="form-group">
            <label for="address2">Address 2</label>
            <input type="text" 
                [(ngModel)]="address2" 
                name="address2" 
                class="form-control" 
                id="address2"
                autocomplete="off">
        </div>
        <div class="form-group">
            <label for="address2">Address 3</label>
            <input type="text"
                [(ngModel)]="address3" 
                name="address3" 
                class="form-control" 
                id="address3"
                autocomplete="off">
        </div>
        <div class="d-flex w-100">
            @if (country == 'USA') {
                <!-- Bureau Mode -->
                <div *sm-tenant-has-facet="TENANT_PERMISSIONS.Flag_Base_Work_Accounts_BureauMode" class="d-flex w-100">
                    <div class="form-group me-2 col-sm-3">
                        <label for="zip">ZIP Code<span class="text-danger">*</span></label>
                        <kendo-combobox
                            [data]="(zipCodes$ | async) || []"
                            [(ngModel)]="zip"
                            [allowCustom]="true"
                            name="zip"
                            id="zip"
                            (ngModelChange)="updateOneAndOnlyOneGeneralCSZFields('zipCode')">
                        </kendo-combobox>
                    </div>
                    <div class="form-group me-2" style="flex:1">
                        <label for="city">City<span class="text-danger">*</span></label>
                        <kendo-combobox
                            [data]="(cities$ | async) || []"
                            [(ngModel)]="city"
                            [allowCustom]="true"
                            name="city"
                            id="city"
                            (ngModelChange)="updateOneAndOnlyOneGeneralCSZFields('city')">
                        </kendo-combobox>
                    </div>
                    <div class="form-group col-sm-2">
                        <label for="state">State <span class="text-danger">*</span></label>
                        <kendo-combobox
                            [data]="(states$ | async) || []"
                            [(ngModel)]="state"
                            [allowCustom]="true"
                            name="state"
                            id="state"
                            (ngModelChange)="updateOneAndOnlyOneGeneralCSZFields('state')">
                        </kendo-combobox>
                    </div>
                </div>
                <!-- Non-Bureau Mode -->
                <div *sm-tenant-has-not-facet="TENANT_PERMISSIONS.Flag_Base_Work_Accounts_BureauMode" class="d-flex w-100">
                    <div class="form-group me-2" style="flex:1">
                        <label for="city">City<span class="text-danger">*</span></label>
                        <input type="text" [(ngModel)]="city" name="city" class="form-control" id="city" autocomplete="off">
                    </div>
                    <div class="form-group col-sm-2">
                        <label for="state">State <span class="text-danger">*</span></label>
                        <select class="form-select form-control" [(ngModel)]="state" name="state" id="state" required>
                            <option *ngFor="let state of us_states" [ngValue]="state.Abbreviation">
                                {{state.Abbreviation}}
                            </option>
                        </select>
                    </div>
                    <div class="form-group ms-2 col-sm-3">
                        <ng-container *ngTemplateOutlet="USAZIP"></ng-container>
                    </div>
                    <ng-template #USAZIP>
                        <label for="zip">ZIP Code<span class="text-danger">*</span></label>
                        <input type="text" [(ngModel)]="zip" name="zip" class="form-control" id="zip" autocomplete="off"/>
                    </ng-template>
                </div>
            } @else if (country == 'CAN') {
                <div class="form-group me-2" style="flex:1">
                    <label for="city">Municipality<span class="text-danger">*</span></label>
                    <input type="text" [(ngModel)]="city" name="city" class="form-control" id="city" autocomplete="off"/>
                </div>
                <div class="form-group">
                    <label for="state">Province/Territory <span class="text-danger">*</span></label>
                    <select id="state" class="form-select form-control" [(ngModel)]="state">
                        <option *ngFor="let prov of can_provinces" [ngValue]="prov.Abbreviation">{{prov.Name}}</option>
                    </select>
                </div>
                <div class="form-group ms-2 col-sm-3">
                    <label for="zip">Postal Code<span class="text-danger">*</span></label>
                    <input type="text" [(ngModel)]="zip" name="zip" class="form-control" id="zip" autocomplete="off"/>
                </div>
            } @else if (country == 'GBR') {
                <div class="form-group me-2" style="flex:1">
                    <label for="city">Town/City<span class="text-danger">*</span></label>
                    <input type="text" [(ngModel)]="city" name="city" class="form-control" id="city" autocomplete="off"/>
                </div>
                <div class="form-group">
                    <label for="state">Locality</label>
                    <input id="state" class="form-control" [(ngModel)]="state" />
                </div>
                <div class="form-group ms-2 col-sm-3">
                    <label for="zip">Postcode<span class="text-danger">*</span></label>
                    <input type="text" [(ngModel)]="zip" name="zip" class="form-control" id="zip" autocomplete="off"/>
                </div>
            }
        </div>

        <!-- County and Unincorporated fields for USA -->
        @if (country == 'USA') {
            <div class="form-group d-flex">
                <div class="county flex-grow-1 me-3">
                    <label for="county">County</label>
                    <ng-container *sm-tenant-has-facet="TENANT_PERMISSIONS.Flag_Base_Work_Accounts_BureauMode">
                        <kendo-combobox
                            [data]="(counties$ | async) || []"
                            [(ngModel)]="county"
                            [allowCustom]="true"
                            name="county"
                            id="county"
                            (ngModelChange)="updateOneAndOnlyOneGeneralCSZFields('county')">
                        </kendo-combobox>
                    </ng-container>
                    <ng-container *sm-tenant-has-not-facet="TENANT_PERMISSIONS.Flag_Base_Work_Accounts_BureauMode">
                        <input type="text"
                            [(ngModel)]="county"
                            name="county"
                            class="form-control"
                            id="county"
                            autocomplete="off">
                    </ng-container>
                </div>
                <div class="custom-control form-check unincorporated align-self-end">
                    <input
                        type="checkbox"
                        class="form-check-input"
                        id="unincorporated"
                        name="unincorporated"
                        [(ngModel)]="unincorporated"
                    >
                    <label class="form-check-label" for="unincorporated">
                        Unincorporated
                    </label>
                </div>
            </div>
        }
        
        <div class="form-group">
            <label for="taxLocation">Tax Location</label>
            <input type="text" 
                [(ngModel)]="taxLocation" 
                name="taxLocation" 
                class="form-control"
                id="taxLocation" 
                autocomplete="off">
        </div>
    </div>
    </div>
</div>

<div *ngIf="errorMessage" class="alert alert-danger">
    {{errorMessage}}
</div>
<div class="modal-footer">
    <ng-container *sm-has-not-env-flag="'auroraV1'">
        <ng-container *ngIf="accountCreationCurrentStep == 0">
            <button unity-button
                    id="AccountCreationNextButton"
                    [disabled]="disableNext()"
                    class="primary"
                    (click)="next()">
                Next
            </button>
        </ng-container>
        <ng-container *ngIf="accountCreationCurrentStep == 1">
            <div class="button--left">
                <button unity-button
                        id="AccountCreationBackButton"
                        class="tertiary"
                        (click)="back()">
                    Back
                </button>
            </div>
            <button unity-button
                    id="AccountCreationCreateButton"
                    [disabled]="disableCreateAccount()"
                    class="primary"
                    (click)="createAccount(false)">
                Create {{ "Account" | smNomenclatureByRegion : program?.Id | async }}
            </button>
            <button unity-button
                    id="AccountCreationCreateAndStartNewWorkflowButton"
                    [disabled]="disableCreateAccount()"
                    class="secondary ms-1"
                    (click)="createAccount(true)">
                <ng-container *sm-tenant-has-facet="TENANT_PERMISSIONS.AdvancedWorkflows">
                    Create {{ "Account" | smNomenclatureByRegion : program?.Id | async }} & Start New Business
                </ng-container>
                <ng-container *sm-tenant-has-not-facet="TENANT_PERMISSIONS.AdvancedWorkflows">
                    Create {{ "Account" | smNomenclatureByRegion : program?.Id | async }} & Start New Quote
                </ng-container>
            </button>
        </ng-container>
        <button unity-button
                id="AccountCreationCancelButton"
                class="ghost"
                (click)="activeModal.close()">
            Cancel
        </button>
    </ng-container>
    <ng-container *sm-has-env-flag="'auroraV1'">
        <ng-container *ngIf="accountCreationCurrentStep == 0">
            <aurora-button
                    id="AccountCreationNextButton"
                    [disabled]="disableNext()"
                    (click)="next()">
                Next
            </aurora-button>
        </ng-container>
        <ng-container *ngIf="accountCreationCurrentStep == 1">
            <div class="button--left">
                <aurora-button
                        id="AccountCreationBackButton"
                        variant="tertiary"
                        (click)="back()">
                    Back
                </aurora-button>
            </div>
            <aurora-button
                    id="AccountCreationCreateButton"
                    [disabled]="disableCreateAccount()"
                    (click)="createAccount(false)">
                Create {{ "Account" | smNomenclatureByRegion : program?.Id | async }}
            </aurora-button>
            <aurora-button
                    id="AccountCreationCreateAndStartNewWorkflowButton"
                    [disabled]="disableCreateAccount()"
                    variant="secondary"
                    class="ms-1"
                    (click)="createAccount(true)">
                <ng-container *sm-tenant-has-facet="TENANT_PERMISSIONS.AdvancedWorkflows">
                    Create {{ "Account" | smNomenclatureByRegion : program?.Id | async }} & Start New Business
                </ng-container>
                <ng-container *sm-tenant-has-not-facet="TENANT_PERMISSIONS.AdvancedWorkflows">
                    Create {{ "Account" | smNomenclatureByRegion : program?.Id | async }} & Start New Quote
                </ng-container>
            </aurora-button>
        </ng-container>
        <aurora-button
                id="AccountCreationCancelButton"
                variant="ghost"
                (click)="activeModal.close()">
            Cancel
        </aurora-button>
    </ng-container>                 
</div>
